import { Component } from '@angular/core';

@Component({
    selector: 'cash-logout',
    templateUrl: './logout.component.html',
    styleUrls: ['./logout.component.scss'],
    standalone: false
})
export class LogoutComponent {}
